const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'internalbilling',
        api_data_path: 'internalBillings',
        namespace: 'internal_billing'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {id, wait = false}) => {
      let params = {
        wait: wait,
        api_url: 'internalbilling',
        namespace: 'internal_billing',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/internal_billing.js